import type { CurrencyOption } from '@shared/config';

/** 회수 유형(코드: @d3/interface ExitTypeOption) */
export type ExitType = 'PARTIAL_EXIT' | 'COMPLETE_EXIT' | 'SHUTDOWN' | 'WRITE_DOWN';

export const EXIT_BADGE_TYPES = ['complete-exit', 'partial-exit'] as const;

/** `ExitBadge` 의 type(Figma variant 이름과 같다) */
export type ExitBadgeType = (typeof EXIT_BADGE_TYPES)[number];

/** COMPLETE_EXIT · PARTIAL_EXIT 만 배지가 있다. 그 외 · 없음은 null — 부르는 쪽이 그리지 않는다 */
export function toExitBadgeType(type: ExitType | null | undefined): ExitBadgeType | null {
  if (type === 'COMPLETE_EXIT') return 'complete-exit';
  if (type === 'PARTIAL_EXIT') return 'partial-exit';
  return null;
}

/** 회수 방법(코드: InvestExitOption). 라벨은 `INVEST_EXIT_WAY_LABEL` */
export type InvestExitWay = 'IPO' | 'MnA' | 'Secondary' | 'Redemption';

/** 회수 기록 한 건(코드: InvestmentExitHistory) */
export interface ExitRecord {
  id: string;
  /** YYYY-MM-DD */
  exitAt: string;
  exitType: ExitType;
  exitWay: InvestExitWay | null;
  exitVolume: number;
  stockAmount: number;
  stockPrice: number;
  exchangeRate: number;
  exchangeUnit: CurrencyOption;
  fund: { idx: number; name: string };
}
